import React from "react";
import { useParams } from "react-router-dom";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";
import { apiPath } from "../../utility/Constant";

const UserUpdate = () => {
  const { users } = apiPath;
  const user = useParams();

  const [userLists, userListLoading] = useFetch(users, false, user.id);
  if (userListLoading) {
    return <Loading />;
  }
  const { email, firstName, role } = userLists;

  const data = [
    {
      elementType: "input",
      label: "User Email",
      type: "Text",
      name: "email",
      defaultValue: email.split("@")[0],
      required: true,
      disabled: true,
    },
    {
      elementType: "input",
      label: "User Name",
      type: "Text",
      name: "firstName",
      defaultValue: firstName,
      required: true,
    },
    {
      elementType: "input",
      label: "User Password",
      type: "Text",
      name: "password",
      required: true,
    },
    {
      elementType: "select",
      label: "User Role",
      type: "Text",
      name: "role",
      defaultValue: role,
      required: true,
      options: ["admin", "moderator"],
    },
  ];

  const update = (data) => {
    updateData(`${users}/${user.id}`, data);
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default UserUpdate;
